import { TestStep } from '../models/test-case.model';
import { TdbOverride } from './tcdl-ops';

/**
 * Vollstaendiges TDB-Override eines MODULE_REF-Schritts, wie der Modul-Drawer es
 * ans aufrufende Formular zurueckgibt (NEX-1052).
 *
 * <p>Der Typ stand vorher dreimal als Inline-Literal im Code (Drawer-Output,
 * Testfall-Formular, Modul-Formular) — sgraetz-Review NEX-1052.
 */
export interface TdbOverrideDelta {
  stepId: string;
  dataSheetId: string | null;
  dataSheetFilters: Record<string, string>[] | null;
  stepCondition: Record<string, string> | null;
  /**
   * Halbe Eingabe aus dem Drawer. `stepCondition` behaelt dann die zuletzt vollstaendige
   * Bedingung, deshalb braucht die Zeile den Entwurf, um die Sperre zu halten.
   */
  override?: TdbOverride;
}

/** Traegt das Override in den adressierten Schritt ein; alle anderen bleiben identisch. */
export function applyTdbOverride(steps: readonly TestStep[], delta: TdbOverrideDelta): TestStep[] {
  return steps.map((step) =>
    step.id === delta.stepId
      ? {
          ...step,
          dataSheetId: delta.dataSheetId,
          dataSheetFilters: delta.dataSheetFilters,
          stepCondition: delta.stepCondition,
        }
      : step,
  );
}
